const helpers = {
  validateId: function (id) {
    var valid = id.match(/^[0-9a-fA-F]{24}$/);
    return valid ? valid.length != 0 : false;
  },
};

export default helpers;
